module.exports = __webpack_public_path__ + "static/media/shopify14.a7afe112.png";